/*==================================================
REPLICA RACK
IN MOTION
Luxury Motion Engine V2
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

const section=document.querySelector("#rr-motion");

if(!section) return;

const viewport=section.querySelector("[data-rr-motion]");

const slider=section.querySelector("[data-slider]");

const slides=[...section.querySelectorAll("[data-slide]")];

const videos=slides.map(slide=>slide.querySelector("video"));

let activeIndex=0;

let sectionVisible=false;

let scrollTimer=null;

let resizeTimer=null;

let dragging=false;

/*==========================================
Lazy Load Videos
==========================================*/

videos.forEach(video=>{

if(!video) return;

video.preload="none";

video.playsInline=true;

video.muted=true;

video.controls=false;

});

/*==========================================
Intersection Observer
==========================================*/

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

sectionVisible=entry.isIntersecting;

if(sectionVisible){

playActiveVideo();

}else{

pauseAllVideos();

}

});

},{

threshold:.55

});

observer.observe(section);

/*==========================================
Pause All
==========================================*/

function pauseAllVideos(){

videos.forEach(video=>{

if(!video) return;

video.pause();

});

}

/*==========================================
Reset Video
==========================================*/

function resetVideo(video){

if(!video) return;

video.pause();

video.currentTime=0;

}

/*==========================================
Play Active
==========================================*/

function playActiveVideo(){

if(!sectionVisible) return;

videos.forEach((video,index)=>{

if(!video) return;

if(index===activeIndex){

video.preload="auto";

video.play().catch(()=>{});

}else{

video.pause();

}

});

}

/*==========================================
Find Active Slide
==========================================*/

function updateActiveSlide(){

const sliderCenter=

slider.scrollLeft+

slider.offsetWidth/2;

let nearest=0;

let smallest=Infinity;

slides.forEach((slide,index)=>{

const center=

slide.offsetLeft+

slide.offsetWidth/2;

const distance=Math.abs(center-sliderCenter);

if(distance<smallest){

smallest=distance;

nearest=index;

}

});

if(nearest===activeIndex) return;

slides[activeIndex].classList.remove("active");

activeIndex=nearest;

slides[activeIndex].classList.add("active");

playActiveVideo();

}
/*==========================================
Center Active Slide
==========================================*/

function centerSlide(index,smooth=true){

const slide=slides[index];

if(!slide) return;

const target=

slide.offsetLeft-

(slider.clientWidth/2)+

(slide.clientWidth/2);

slider.scrollTo({

left:target,

behavior:smooth ? "smooth" : "auto"

});

}

/*==========================================
Next Slide
==========================================*/

function nextSlide(){

let next=activeIndex+1;

if(next>=slides.length){

next=0;

}

centerSlide(next);

}

/*==========================================
Video End
==========================================*/

videos.forEach(video=>{

if(!video) return;

video.addEventListener("ended",()=>{

nextSlide();

});

});

/*==========================================
Scroll Detection
==========================================*/

slider.addEventListener("scroll",()=>{

window.cancelAnimationFrame(scrollTimer);

scrollTimer=

window.requestAnimationFrame(()=>{

updateActiveSlide();

});

});

/*==========================================
Dragging
==========================================*/

slider.addEventListener("pointerdown",()=>{

dragging=true;

slider.classList.add("dragging");

});

window.addEventListener("pointerup",()=>{

dragging=false;

slider.classList.remove("dragging");

});

/*==========================================
Resize
==========================================*/

window.addEventListener("resize",()=>{

clearTimeout(resizeTimer);

resizeTimer=setTimeout(()=>{

centerSlide(activeIndex,false);

},150);

});

/*==========================================
Keyboard Support
==========================================*/

window.addEventListener("keydown",event=>{

if(!sectionVisible) return;

if(event.key==="ArrowRight"){

nextSlide();

}

if(event.key==="ArrowLeft"){

let prev=activeIndex-1;

if(prev<0){

prev=slides.length-1;

}

centerSlide(prev);

}

});

/*==========================================
Initial State
==========================================*/

slides[0].classList.add("active");

centerSlide(0,false);

playActiveVideo();

});